
import { ref, onMounted, inject, shallowRef, reactive } from "vue";
import { Toast } from 'vant'
import { useRoute } from "vue-router";
import $http  from '@/plugins/http'
export default {
  // props: ['cancellationInfo'],
  setup(props: any, ctx: any) {
    const $route:any = useRoute()
    const systypeType = ref('')
    const fromToken = ref('')
    const monthDay = ref('')
    const yearDate = ref('')
    const cancellationInfo: any = ref({})
    // const logout_Date = cancellationInfo.endDate
    const handleCancelAppicationClick = async() => {
      if (systypeType.value === 'lite') {
        try {
          const res = await $http.cancelAccountApplicationLite({'pfx-accesstoken': fromToken.value})
          if (res.code == 0) {
            Toast({message: "Cancel success"})
            ctx.emit('liteRefresh')
          }
        } catch(e) {
          console.error(e)
        }
      } else { 
        try {
          const res = await $http.cancelAccountApplication({ 'authorization': 'Bearer ' + fromToken.value })
          if (res.code == 200) {
            Toast({message: "Cancel success"})
            ctx.emit('kiliRefresh')
          }
        } catch(e) {
          console.error(e)
        }
      }
    }

     // lite 查询账户注销状态
     const checkAccountCancellationLite = async() => {
      const res = await $http.getAccountStateLite({'pfx-accesstoken': fromToken.value})
      cancellationInfo.value = res.data
      logoutDate(res.data.endDate)
    }

    // k 查询账户注销状态
    const checkAccountCancellationKili = async () => {
      const res = await $http.getAccountStateKili({ 'authorization': 'Bearer ' + fromToken.value })
      // 0 可注销 1-注销中 2-已注销  3-取消注销
      cancellationInfo.value = res.data
      logoutDate(res.data.logout_date)
    }

    const logoutDate = (date: any) => {
      const monthsInEng = ["January","February","March","April","May","June","July","August","September","October","November","December"]
      const time = new Date(date)
      const year: any = time.getFullYear()
      const month = monthsInEng[time.getMonth()]
      const day = time.getDate()
      monthDay.value = month + ' ' + day
      yearDate.value = year
    }

    onMounted(() => {
      const { token, systype } = $route.query
      systypeType.value = systype
      fromToken.value = token
      if (systype === 'lite') {
        checkAccountCancellationLite()
      } else {
        checkAccountCancellationKili()
      }
    })

    return {
      yearDate,
      monthDay,
      systypeType,
      cancellationInfo,
      logoutDate,
      handleCancelAppicationClick,
      checkAccountCancellationLite,
      checkAccountCancellationKili
    };
  },
};
